import { ReactElement, ReactNode } from 'react';
import styles from './TimeSpanSection.module.scss';

const TimeSpanSection = ({ children }: { children: ReactNode }): ReactElement => {
  return <dl className={styles.container}>{children}</dl>;
};

export default TimeSpanSection;
